import { connect } from "react-redux";
import PmTickets from "./pmTicket";
import { bindActionCreators } from "redux";
import {fetchPmTicket, getPmTicketsFilterDropDown} from "services/redux/maintenance/pmTicket/action";

const mapStateToProps = (state) => ({
    pmTicket: state.pmTicketReducer.pmTicket,
    pmTicketFilter: state.pmTicketReducer.pmTicketFilter,

});

const mapDispatchToProps = (dispatch) =>
  bindActionCreators(
    {
        fetchPmTicket,
        getPmTicketsFilterDropDown,
    },
    dispatch
  );

export default connect(mapStateToProps, mapDispatchToProps)(PmTickets);
